import { useMutation, useQueryClient } from "@tanstack/react-query";

import { queries } from "@/api/graphql/constants";

import type { deleteTidLinkedAccount } from "./api";

type UseDeleteTidLinkedAccountParams = {
  deleteTidLinkedAccountFn: typeof deleteTidLinkedAccount;
};

export const useDeleteTidLinkedAccount = ({
  deleteTidLinkedAccountFn,
}: UseDeleteTidLinkedAccountParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => deleteTidLinkedAccountFn(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queries.GET_TID_LINKED_ACCOUNTS],
      });
    },
  });
};
